import { makeTokenStore } from './tokenStorage';

// 管理者トークン：30分の短命セッションなので、タブを閉じたら消えるsessionStorageに保存する。
const store = makeTokenStore(sessionStorage, 'gj_admin_token');

export const saveAdminToken = store.save;
export const clearAdminToken = store.clear;
export const getStoredAdminToken = store.get;
